<template>
<div id="ccMensagem">

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <!-- <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true"> -->
    <div class="modal-dialog modal-dialog-centered">

      <div class="modal-content" v-bind:class="[cor==1 ? 'modal-content-verde': cor==2 ? 'modal-content-vermelho' : 'modal-content-azul' ]">
        <div class="modal-body">
            <div class="text_18 mb-1" v-bind:class="[cor==1 ? 'text_verde': cor==2 ? 'text_vermelho' : 'text_azul' ]"> <b>{{titulo}}</b> </div>
            <div class="text_15 mb-3 text_cinza text_bold" v-if="torneio"> ATENÇÃO SERÁ DESCONTADO R${{torneio.taxa_entrada}} </div>
            <div class="text_15 mb-3 text_cinza text_bold" v-else="torneio"> É preciso escolher o valor da entrada para entrar em um torneio. </div>
            <div class="mb-4 text_cinza"> <b>{{texto}}</b> </div>
            <div class="row">
            <div class="col-md-6">
                <button v-show="btn1_ativo" type="button" class="btn btn-sm w-100 mb-3 text_bold"
                data-bs-dismiss="modal" @click="rota(1)" v-bind:class="[ btn1_cor==1 ? 'btn-success' : btn1_cor==2 ? 'btn-danger' : 'btn-info' ]">
                {{btn1_texto}}
                </button>
            </div>
            <div class="col-md-6">
                <button v-show="btn2_ativo" type="button" class="btn btn-sm w-100 text_bold"
                data-bs-dismiss="modal" @click="rota(2)" v-bind:class="[ btn2_cor==1 ? 'btn-success' : btn2_cor==2 ? 'btn-danger' : 'btn-info' ]">
                {{btn2_texto}}
                </button>
            </div>
            </div>
        </div>
      </div>

    </div>
  </div>

</div>
</template>

<script>

  export default {

    name: 'ccMensagem',

    data(){
      return{
        obj: {},
        cor: 1,
        torneio: {},
        titulo: 'Não tem titulo',
        texto: 'Não tem texto',
        btn1_ativo: false,
        btn1_cor: null,
        btn1_texto: null,
        btn1_link: null,
        btn1_link_next: false,
        btn2_ativo: false,
        btn2_cor: null,
        btn2_texto: null,
        btn2_link: null,
        btn2_link_next: false,
      }
    },

    methods: {

      receber_dados(obj){
        this.cor = obj.cor
        this.torneio = obj.torneio
        this.titulo = obj.titulo
        this.texto = obj.texto
        this.btn1_ativo = obj.btn1_ativo
        this.btn1_cor = obj.btn1_cor
        this.btn1_texto = obj.btn1_texto
        this.btn1_link = obj.btn1_link
        this.btn1_link_next = obj.btn1_link_next
        this.btn2_ativo = obj.btn2_ativo
        this.btn2_cor = obj.btn2_cor
        this.btn2_texto = obj.btn2_texto
        this.btn2_link = obj.btn2_link
        this.btn2_link_next = obj.btn2_link_next
        var myModal = new bootstrap.Modal(document.getElementById('staticBackdrop'))
        myModal.show()
      },

      rota(botao){
        if(botao == 1 && this.btn1_link_next == true){
          this.$router.push({ path: this.btn1_link, replace: true })
        }
        if(botao == 2 && this.btn2_link_next == true){
          this.$router.push({ path: this.btn2_link, replace: true })
        }
        if(botao == 1 && this.btn1_link_next == false){
          this.$emit('evento_teste', true);
        }
      },

    },

  }

</script>


<style scoped>
    .modal-content{
      background: transparent linear-gradient(68deg, #071A24 0%, #000000 100%) 0% 0% no-repeat padding-box;
    }
    .modal-content-verde{
      border-left: solid 10px #5ABB10;
    }
    .modal-content-vermelho{
      border-left: solid 10px red;
    }
    .modal-content-azul{
      border-left: solid 10px blue;
    }
</style>


// WEBPACK FOOTER //
// src/components/cc_geral/mensagem_turbo.vue